// 254测试
// const baseUrl = "http://127.0.0.1:8014"
// const baseImgUrl = "http://127.0.0.1:8014"
// const homeImgBaseUrl = "http://127.0.0.1:8014/photo"

// // 237线上测试
// const baseUrl = "http://192.168.1.15:85"
// const baseUrl = "http://222.76.214.237:9596"
// const baseImgUrl = "http://222.76.214.237:8089"
// const homeImgBaseUrl = "http://222.76.214.237:8089/photo"

// 9595线上测试
// const baseUrl = "http://222.76.214.247:9595"
// const baseImgUrl = "http://222.76.214.247:8089"
// const homeImgBaseUrl = "http://222.76.214.247:8089/photo"

// 222正式
// const baseUrl = "http://119.29.107.222"
// const baseImgUrl = "http://119.29.107.222:8089"
// const homeImgBaseUrl = "http://119.29.107.222:8089/photo"

// https 222正式
// const baseUrl = "http://192.168.100.3:8888/"
// const baseImgUrl = "http://192.168.100.3:8888/"
// const homeImgBaseUrl = "http://192.168.100.3:8888/"

// https 222正式
// const baseUrl = "https://test.zhgadmin.hefeng.info/webapi"
// const baseUrl = "http://localhost:8014"
// const baseImgUrl = "https://test.zhgadmin.hefeng.info/photo"
// const homeImgBaseUrl = "https://test.zhgadmin.hefeng.info/photo"

// 生产正式预发布环境
// const baseUrl = "http://test_api.qzztcn.cn"
// const baseImgUrl = "http://test_api.qzztcn.cn"
// const homeImgBaseUrl = "http://test_api.qzztcn.cn/photo"

// https 222正式
// const baseUrl = "https://api.qzztcn.com"
// const baseImgUrl = "https://api.qzztcn.com"
// const homeImgBaseUrl = "https://api.qzztcn.com/photo"
// const baseApi = "https://api.qzztcn.com/xml" //运单

// 测试环境
// const baseUrl = 'http://116.62.35.127:7777' // 使用这一项开发时登录后又跳回登录页的问题可能是session丢失cookie域不对
// const baseUrl = ''
// const baseApi = "http://116.62.35.127:9886/xml" //运单
// const baseImgUrl = "http://test.qzztcn.com/files"
// const homeImgBaseUrl = "http://116.62.35.127:7777/photo"

// 本地环境
// const baseUrl = 'http://127.0.0.1:7777'
// const baseUrl = ''
// const baseApi = "http://127.0.0.1:9886/xml"
// const baseImgUrl = "http://127.0.0.1:8000/ufile"
// const homeImgBaseUrl = "http://116.62.35.127:7777/photo"

export default {
  baseImgUrl: process.env.BASE_IMG_URL,
  homeImgBaseUrl: process.env.HOME_IMG_BASE_URL,
  baseUrl: process.env.BASE_URL,
  baseApi: process.env.BASE_API,
  formatTimeStamp(timeStamp) {
    let myDate = new Date(timeStamp)
    let year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    return `${year}/${month}/${day}`
  },
  //时间戳转日期 yyyy-mm-dd
  formatTimeStampLine(timestamp) {
    let myDate = new Date(timestamp)
    let year = myDate.getFullYear()
    let month =
      myDate.getMonth() + 1 >= 10
        ? `${myDate.getMonth() + 1}`
        : `0${myDate.getMonth() + 1}`
    let day =
      myDate.getDate() >= 10 ? `${myDate.getDate()}` : `0${myDate.getDate()}`
    return `${year}-${month}-${day}`
  },
  formatDate(str) {
    let myDate = new Date(str)
    let timestamp = myDate.getTime()
    return timestamp
  },
  formatDateTime(dateTime) {
    // 获取传入的日期时间
    const nDate = new Date(dateTime)
    // 获取传入日期的年份
    const year = nDate.getFullYear();
    // 获取传入日期的月份，从0开始，加1到正常月份
    const month = (nDate.getMonth() + 1).toString().padStart(2, 0);
    // 获取传入日期的日子
    const day = nDate.getDate().toString().padStart(2, 0);

    // 获取传入日期的小时
    const hh = nDate.getHours().toString().padStart(2, 0);
    // 获取传入日期的分钟
    const mm = nDate.getMinutes().toString().padStart(2, 0);
    // 获取传入日期的秒数
    const ss = nDate.getSeconds().toString().padStart(2, 0);

    // 返回日期格式
    return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
  },
  // 对{对象}进行一个反义
  handleSense(str) {
    let resss = new RegExp(":", "g")
    let reg = str.replace(resss, ":")
    return reg
  },
  uploadFile(file, _this) {
    return new Promise((resolve, reject) => {
      event.preventDefault()
      _this.$axios
        .post("/admin/uploadimg", file, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          if (res.data.result) {
            resolve(res.data)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/config.js